export default () => ({
    menu: [],
    menuFlat: []
});
